





















import { getXYForLatLng } from "@/lib/leaflet-util";
import { useDeskStore } from "@/pinia/desk-store";
import { FloorplanMarker, useFloorplanStore } from "@/pinia/floorplan-store";
import { extractDeskNumber } from "@ciao/features/src/features/InteractiveFloorplan/util";
import { ComponentInstance, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import { LMap, LImageOverlay, LMarker } from "vue2-leaflet";
import { CRS, Map, DivIcon, LatLngTuple, LatLng } from "leaflet";

// Vue2-leaflet docs: https://vue2-leaflet.netlify.app/components/

export default defineComponent({
    name: "floorplanMap",
    components: {
        LMap,
        LImageOverlay,
        LMarker,
    },
    setup(props, ctx) {
        const floorplanStore = useFloorplanStore();
        const deskStore = useDeskStore();

        const map = ref<(ComponentInstance & { mapObject: Map }) | null>(null);
        const zoomLevel = ref(1);

        // Once the map(object) is available, set bounds / zoom / and limit panning and zooming
        watch(map, () => {
            if (!map.value) return;
            const mapObject = map.value.mapObject as Map;
            mapObject.fitBounds(floorplanStore.bounds);
            mapObject.setMaxBounds(floorplanStore.bounds);
            mapObject.setMinZoom(mapObject.getZoom());
            mapObject.setMaxZoom(mapObject.getZoom() + 3);
            mapObject.addEventListener("zoomanim", (e) => {
                zoomLevel.value = e.zoom;
            });

            zoomLevel.value = mapObject.getZoom();
        });

        const generateIcon = (marker: FloorplanMarker) => {
            const scale = 0.001 * Math.pow(2, zoomLevel.value) * floorplanStore.floor.markerScale;

            // Decide on initials to show. We don't show initials in edit mode
            let initials = extractDeskNumber(marker.desk.name);
            if (!floorplanStore.editMode && marker.desk.reservations.length > 1) initials = "…";
            else if (!floorplanStore.editMode && marker.desk.reservations.length === 1)
                initials =
                    // @ts-ignore
                    marker.desk.reservations[0].user.firstName[0].toUpperCase() +
                    // @ts-ignore
                    marker.desk.reservations[0].user.lastName[0].toUpperCase();

            let status: string;
            if (floorplanStore.editMode) {
                status = "available";
            } else {
                status = marker.status;

                // Temporary: if any of the reservations have a checkinAt but no checkoutAt, show the marker
                // as being checked in
                if (marker.reservations && marker.reservations.some((r) => r.checkinAt && !r.checkoutAt)) {
                    status = "checked-in";
                }
            }

            if (floorplanStore.selectedMarker === marker) status = "selected";

            return new DivIcon({
                className: "", // clear the leaflet default class
                html: `<div class='floorplan-marker floorplan-marker--${status}' style='transform: scale(${scale})'>${initials}</div>`,
                iconSize: [24, 24],
            });
        };

        const moveMarker = async (marker: FloorplanMarker, latLng: LatLng) => {
            const xy = getXYForLatLng(floorplanStore.bounds, latLng);
            await deskStore.patch(marker.desk.id, {
                x: xy.x,
                y: xy.y,
            });
        };

        return { floorplanStore, map, CRS, generateIcon, moveMarker };
    },
});
